import { api } from "@/lib/api";
import { notifications } from "@mantine/notifications";

/**
 * Fetches a file from an authenticated API endpoint as a blob and triggers a
 * browser download. Shared by every document-download path: alert previews and
 * purchased documents on the dashboard, the purchased-documents list, and the
 * checkout success page. Shows an error notification on failure.
 *
 * Endpoint selection and any domain guards (e.g. expiry) belong to the caller.
 */
export const downloadFile = async (
  endpoint: string,
  fileName: string
): Promise<void> => {
  try {
    const blob: Blob = await api.get(endpoint, { responseType: "blob" });
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(downloadLink.href);
  } catch (error) {
    console.error("Download error:", error);
    notifications.show({
      title: "Error",
      message: "Failed to download document",
      color: "red",
      position: "top-center",
      "aria-live": "polite",
      closeButtonProps: {
        "aria-label": "Close error notification",
      },
    });
  }
};
